import { useRootStore } from '../stores/root.store';
import { pick } from '@/utilities/helpers';
import Application from './onboarding/application.model';
import Applicant from './onboarding/applicant.model';

export default class User {
  status = 'PENDING';
  firstName = null;
  lastName = null;
  email = null;

  // memoized relationships
  accounts = null;
  preferences = null;

  constructor(firstName, lastName, email, status = 'PENDING') {
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.status = status;

    // if (this.isActive) {
    //   this.initialize();
    // }
  }

  async initialize() {
    this.accounts = await useRootStore().tradierService.fetchAccounts();
    // this._preferences = useRootStore().dashService.fetchPreferences();
  }

  get fullName() {
    return [this.firstName, this.lastName].filter((name) => name).join(' ');
  }

  get applications() {
    return useRootStore().onboardingService.fetchApplications();
  }

  get isActive() {
    return this.status === 'ACTIVE';
  }

  createApplication(options = {}) {
    const rootStore = useRootStore();
    const cookieParams = rootStore.cookieService.getOnboardingParamsFromCookie() || {};
    rootStore.cookieService.clearOnboardingParamsFromCookie();

    options.promotionCode = cookieParams.promotionCode || options.promotionCode || undefined;
    options.platformId = cookieParams.platformId || options.platformId || undefined;

    // add google meta if parameter exists
    const googleParams = pick(cookieParams, ['gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term']);
    if (Object.keys(googleParams).length > 0) {
      options.meta = googleParams;
    }

    options.applicants = [
      new Applicant({
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
      }),
    ];

    return rootStore.onboardingService.createApplication(new Application(options));
  }

  restartApplication(application) {
    const options = {
      promotionCode: application.promotionCode,
      platformId: application.platformId,
      meta: application.meta,
    };

    application.delete();
    return this.createApplication(options);
  }

  static fromJwt(jwt) {
    return new User(jwt.firstName, jwt.lastName, jwt.email, jwt.status);
  }

  static async fromProfile() {
    const rootStore = useRootStore();
    const profile = await rootStore.tradierService.fetchProfile();
    if (!profile) throw new Error('Profile not found');

    return new User(profile.firstName, profile.lastName, profile.email, profile.status);
  }
}
